import { useDarkMode } from "./dark-mode";

const DarkModeToggleButton = (props) => {
    const darkModeState = useDarkMode()
    
    return <button className={[props.className, "btn btn-primary"]} onClick={() => darkModeState.toggle()}>
        {darkModeState.dark ? "DISABLE DARK MODE" : "ENABLE DARK MODE"}
    </button>
}

export default DarkModeToggleButton;